import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NavigationStart, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { FeatureFlags, FeatureFlagService } from '@rma/generic/util/feature-flags';
import { filter, map, Observable, startWith } from 'rxjs';
import { BlogCategory } from '../domain';

@Component({
  selector: 'rma-blog-nav',
  templateUrl: './blog-nav.component.html',
  styleUrls: ['./blog-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    RouterLink,
    RouterLinkActive,
    RmaIconComponent,
    MatChipsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    AsyncPipe,
  ],
})
export class BlogNavComponent implements OnChanges {
  @Input()
  public blogCategories: BlogCategory[] | null = [];

  private readonly additionalBlogUrls: BlogCategory[] = [];
  protected url$: Observable<string>;

  constructor(
    private readonly featureFlagService: FeatureFlagService,
    protected router: Router,
  ) {
    this.url$ = router.events.pipe(
      filter((event) => event instanceof NavigationStart),
      startWith({ url: router.url }),
      map((event: NavigationStart | { url: string }) => event.url),
    );
    const urls = this.featureFlagService.getFeature(FeatureFlags.AdditionalBlogUrls, []);
    if (urls?.length > 0) {
      urls.forEach((u: { name: string; url: string }) =>
        this.additionalBlogUrls.push({ id: -1, parentId: -1, name: u.name, slug: u.url, postCount: 0 }),
      );
    }
  }

  ngOnChanges(): void {
    if (this.additionalBlogUrls?.length > 0) {
      if (this.blogCategories?.length) {
        this.blogCategories = [...this.additionalBlogUrls, ...this.blogCategories];
      } else {
        this.blogCategories = this.additionalBlogUrls;
      }
    }
  }
}
